export const USER_PERMISSION = {
    APPROVAL: 'APPROVAL',
    DRAFT: 'DRAFT',
    INTERNAL_ACCEPTABLE: 'INTERNAL_ACCEPTABLE',
    INTERNAL_DISCUSSABLE: 'INTERNAL_DISCUSSABLE',
    INTERNAL_EDITABLE: 'INTERNAL_EDITABLE',
    PARTNER_ACCEPTABLE: 'PARTNER_ACCEPTABLE',
    PARTNER_DISCUSSABLE: 'PARTNER_DISCUSSABLE',
    PARTNER_EDITABLE: 'PARTNER_EDITABLE',
}